import React from "react";
import "./EquipmentList.css";

const EquipmentItem = async ({ item, onSelect, selectedEquipment }) => {
  let isSelected = selectedEquipment.includes(item.title)
  
  let uri = `/assets/images/rhinoco/${item.image}_${
    isSelected ? "in" : ""
  }active.png`
  const img = await import(uri);


  return (
    <button
      onClick={onSelect(item.title)}
      className={`EquipmentItem ${isSelected ? "isSelected" : ""}`}
    >
      <img src={img} alt={item.title} className="EquipmentImage" />
      <p className="EquipmentLabel">{item.title}</p>
    </button>
  );
};

const EquipmentList = ({ onSelect, selectedEquipment, equipment }) => {
  return (
    <div className="EquipmentList">
      {equipment.map((item, i) => {
        let props = { onSelect, item, selectedEquipment }
        return <EquipmentItem key={i} {...props} />
      })}
    </div>
  );
};

export default EquipmentList;